import React, { Fragment } from "react";
import {Link} from "react-router-dom";
import { SportsBet, ListBetLogsRequest, BetStatus} from "../../http/protocol";
import { getContainer } from "../../ioc/IOCSetup";
import { RouteComponentProps, withRouter } from "react-router";
import { LoadingViewState, RouterView } from "../RouterView";
import { formatDate } from "../../util/date";
import { FormSubmitError, FormSubmitSuccess } from "../form/FormFeedback";
import { Form, FormListener } from "../form/Form";
import { SportBetsService } from "../../services/SportsBetsService";
import { ActionType, DataTable } from "../list/list/DataTable";
import { PagerModel } from "../list/list/PagerModel";
import { ColumnType } from "../list/list/ColumnType";
import { EntityDataTable } from "../list/list/EntityDataTable";
import { ListUtils } from "../list/list/ListUtils";
import { FormInput, StaticFormValue } from "../form/FormInput";
import { Button, FormGroup, Modal } from "react-bootstrap";
import { SelectInput } from "../form/SelectInput";
import { Validators } from "../form/Validators";
import { Submit } from "../form/Submit";


interface PropsModal { 
    onOk?: () => void, 
    onCancel?: () => void,
    onClose?: () => void,
    okClassName?: string,
    cancelClassName?: string,
    cancelLabel?: string,
    descriptionAlert? : boolean,
    heading: string,
    show?: boolean,
    showModalSelectBet?: boolean;
    showModalConfirmation?:boolean;
    showDescriptionTextArea?:boolean,
    okLabel: string,
    bet?:SportsBet,
    service: SportBetsService;
    loadContent: () => void;
}

interface State extends LoadingViewState {
    bet?: SportsBet;
    updateType?: string;
    statutes?:BetStatus;
    validationMap?: any;
    showModal?: boolean;
    showModalSelectBet?: boolean;
    showModalConfirmation?:boolean;
    listRequest?: ListBetLogsRequest;
    lookupExpanded?: boolean;
}

interface Props extends RouteComponentProps {

}

export class BetUpdateModal extends React.Component<PropsModal, State>{

    constructor(props: PropsModal) {
        super(props);
        this.state = { bet: this.props.bet, validationMap: {}, showModal:this.props.show, showModalSelectBet:this.props.showModalSelectBet, showModalConfirmation:this.props.showModalConfirmation};
    }

    async onCancel() {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }

    async onClose() {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    async doOk() {
        if (this.props.onOk) {
            this.props.onOk();
        }
    }

    async loadContent() {
        if (this.props.loadContent) {
            this.props.loadContent();
        }
    }

    goBack(){
        this.setState({showModal:true, showModalSelectBet:true, showModalConfirmation:false})
    }

    toTimeStamp (strDate:string){ 
        const dt = Date.parse(strDate); 
        return dt / 1000; 
    }

    sendData(){
        let bet = this.state.bet;
        if(bet!==undefined){
            if(bet.gradedDate!==undefined){
                let date = bet.gradedDate!.toString();
                let dateSplit=date.split("-");
                let year = dateSplit[0];
                let month = dateSplit[1];
                let day = dateSplit[2];
                let timestamp= (new Date(year+"-"+month+"-"+ day)).getTime() ;
                bet.gradedDate = timestamp;
            }
            this.props.service.updateStatus(bet);
            this.loadContent();
        }
        this.onClose(); 
    }

    
    getActions() {
        let btnCancelClass = this.props.cancelClassName ? this.props.cancelClassName : "btn-primary";
        let btnClass = this.props.okClassName ? this.props.okClassName : "btn-danger";
        let btnCancel = this.props.cancelLabel ? this.props.cancelLabel : "Cancel";
        return (
            <FormGroup className="form-group">
                <div> 
                    <a  className={`btn ${btnCancelClass}`} onClick={()=>{this.goBack()}}>{btnCancel}</a>
                    <a  className={`btn ${btnClass}`} onClick={()=>{this.sendData()}}>{this.props.okLabel}</a>
                </div>
            </FormGroup>
        );
    }

    formDidUpdate(formModel: SportsBet, validationMap : any): void {
        this.setState({ bet : formModel, validationMap : validationMap});
    }

    onSubmit()  {
        this.setState({showModal:true, showModalSelectBet:false, showModalConfirmation:true});
    }

    render() {
        return (
            <Modal show={this.state.showModal} onHide={this.onClose.bind(this)} aria-labelledby="contained-modal-title">
                {
                    this.state.showModalSelectBet && (
                        <><Modal.Header closeButton={this.props.show}>
                            <Modal.Title id="contained-modal-title">{this.props.heading}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            
                            {(this.props.descriptionAlert === undefined || this.props.descriptionAlert === false) && (this.props.showDescriptionTextArea === true) && (
                                <div><textarea title="." className={"form-control chat-input"} rows={10} cols={70} maxLength={1000} disabled={true}>{this.props.description}</textarea></div>
                            )}
                            
                            <Form className="form form-horizontal" validationMap={this.state.validationMap} modelObject={this.state.bet} formListener={this}>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card-box">
                                            <FormGroup className="form-group">
                                                <label className="control-label">Bet Statuses</label>
                                                <div className="col-sm-10">
                                                    <SelectInput model="status" optional={true} values={Object.keys(BetStatus)} className="form-control" />
                                                </div>
                                            </FormGroup>

                                            {
                                                (this.state.bet!.status===BetStatus.WIN || this.state.bet!.status===BetStatus.HALF_WIN) && (
                                                    <><FormGroup className="form-group">
                                                            <label className="control-label">Payout</label>
                                                            <div className="col-sm-10">
                                                                <FormInput model="payout" validators={[Validators.required(), Validators.number()]} type="float" className="form-control" />
                                                                <span className={"help"}>Input final payout amount. If bet was made with BONUS funds be sure to make necessary deductions. i.e. substract risk amount from payout calculated using only odds.</span>
                                                                <span className={"help"}>When payout is 0 or negative number after deductions then submit 0.</span>
                                                            </div>
                                                        </FormGroup><FormGroup className="form-group">
                                                                <label className="control-label">Grade date</label>
                                                                <div className="col-sm-10">
                                                                    <FormInput model="gradedDate" validators={[Validators.required()]} type="date" className="form-control" />
                                                                </div>
                                                            </FormGroup></>
                                                )
                                            }

                                            {
                                                (this.state.bet!.status===BetStatus.PUSH || this.state.bet!.status===BetStatus.CANCELLED
                                                    || this.state.bet!.status===BetStatus.DECLINE || this.state.bet!.status===BetStatus.HALF_LOSE
                                                    || this.state.bet!.status===BetStatus.LOSS) && (
                                                    <FormGroup className="form-group">
                                                    <label className="control-label">Grade date</label>
                                                    <div className="col-sm-10">
                                                        <FormInput model="gradedDate" validators={[Validators.required()]} type="date" className="form-control" />
                                                    </div>
                                                    </FormGroup>
                                                )
                                            }

                                            {
                                                (this.state.bet!.status===BetStatus.REQUESTED || this.state.bet!.status===BetStatus.APPROVED
                                                    || this.state.bet!.status===BetStatus.PENDING || this.state.bet!.status===BetStatus.UNGRADED
                                                    || this.state.bet!.status===BetStatus.UNKNOWN) && (
                                                    <FormGroup />
                                                
                                                )
                                            }
      
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card-box">
                                            <Submit className="btn  btn-primary">Save</Submit>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </Modal.Body></>
                    )
                }
                {
                    this.state.showModalConfirmation && (
                        <><Modal.Header closeButton={this.props.show}>
                            <Modal.Title id="contained-modal-title">{"Do you want to update the status of your bets?"}</Modal.Title>
                        </Modal.Header>
                        <Modal.Footer>
                        {
                            this.getActions()
                        }
                        </Modal.Footer>
                        </>
                    )
                }
            </Modal>
       );
    }
}

export class BetView extends RouterView<Props, State> implements FormListener<SportsBet>{

    service: SportBetsService;
    constructor(props: Props) {
        super(props);
        this.service = getContainer().getSportBetsService();
        this.state = { bet: {}, validationMap: {}, loading: true , showModal: false, listRequest: {}, lookupExpanded:false};
    }

    loadContent(): Promise<any> | undefined {
        let id = (this.props.match.params as any).id;
        return this.service.getEntity(id).then((a: SportsBet) => {
            this.setState({ bet: a, listRequest : {
                betId: a.id,
                limit: 50,
                orderBy: "id",
                ascending: false
            } });
        })
    }

    onSubmit(): Promise<any> | undefined {
        return;
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>) {
        if(this.state.bet!.status!==prevState.bet!.status){
            this.loadContent();
        }
        if(this.state.bet!.gradedDate!==prevState.bet!.gradedDate){
            this.loadContent();
        }
        if(this.state.bet!.payout!==prevState.bet!.payout){
            this.loadContent();
        }
        if(this.state.bet!.payoutAccountRole!==prevState.bet!.payoutAccountRole){
            this.loadContent();
        }
        if(this.state.bet!.originalPayoutAccountRole!==prevState.bet!.originalPayoutAccountRole){
            this.loadContent();
        }
        if(this.state.bet!.originalPayout!==prevState.bet!.originalPayout){
            this.loadContent();
        }
        if(this.state.bet!.riskAccountRole!==prevState.bet!.riskAccountRole){
            this.loadContent();
        }
        if(this.state.bet!.risk!==prevState.bet!.risk){
            this.loadContent();
        }
    }

    formDidUpdate(formModel: SportsBet, validationMap?: any) {
        this.loadContent();
        this.setState({ bet: formModel, validationMap: validationMap })
    }

    getTitle(): string {
        return "Bet Details";
    }

    openModal(){
        this.setState({showModal:true, showModalSelectBet:true, showModalConfirmation:false});
        this.loadContent();
    }

    closeModal(){
        this.setState({showModal:false, showModalSelectBet:false, showModalConfirmation:false});
        this.loadContent();
    }

    confirmationModal(){
        this.setState({showModal:true, showModalSelectBet:false, showModalConfirmation:true});
        this.loadContent();
    }
    
    renderBetSelections(){
        if(!this.state.bet){
            return(<span></span>)
        }

        let pager = new PagerModel(new PagerModel(), this.state.bet.selections!.length);

        return(
        <div className="card-box">
            <div className="ibox-title">
                <h5>Bet Selections</h5>
            </div>
            <div className="ibox-content">
                <DataTable
                    pager={pager}
                    columns={[
                        { property: "event.sportName", name: "Sport"},
                        { property: "categoryName", name: "Category Name"},
                        { property: "event.tournamentName", name: "Tournament"},
                        { property: "event.name", name: "Event Name"},
                        { property: "event.status", name: "Event Status"},
                        { property: "id", name: "Id"},
                        { property: "oddsName", name: "Odds Name"},
                        { property: "currentOddsValue", name: "Odds"},
                        //{ property: "isLive", name: "Is Live"},
                        //{ property: "score", name: "Score"},
                        //{ property: "status", name: "Status"}
                    ]}
                    items={this.state.bet.selections || []}
                    onPagerChange={(pager : PagerModel) => {return;}}
                    loading={false}
                    itemsUpdating={[]}
                >
                </DataTable>
            </div>
        </div>)
    }
  
    pagerChanged(pager : PagerModel) {
        if(!this.state.listRequest) {
            return;
        }
        let listRequest = ListUtils.toListRequest<ListBetLogsRequest>(this.state.listRequest, pager);
        this.setState({listRequest : listRequest});
    }

    renderBetLogs() {
        if (!this.state.listRequest){
            return(<span></span>)
        }
        
        let columns = [
            { property : "id", name : "ID"},
            { property : "timestamp", name : "Timestamp", type : ColumnType.DATE},
            { property : "betType", name : "Type", type: ColumnType.ENUM },
            { property : "provider", name : "Provider" },
            { property : "riskAccountRole", name : "Risk Role", type: ColumnType.ENUM},
            { property : "risk", name : "Risk Amount", renderer: (property: string, name: string, item: SportsBet) => {
                if(item.risk!==undefined){
                    return item.risk+" "+item.currency;
                }
            }},
            { property : "created", name : "Created", type : ColumnType.DATE},
            { property : "gradedDate", name : "Graded", type : ColumnType.DATE},
            { property : "status", name : "Status", type: ColumnType.ENUM},
            { property : "description", name : "Description"},
            { property : "result", name : "Result", type: ColumnType.ENUM},
            { property : "payoutAccountRole", name : "Payout Role", type: ColumnType.ENUM},
            { property : "payout", name : "Payout Amount" , renderer: (property: string, name: string, item: SportsBet) => {
                if(item.payout!==undefined){
                    return item.payout+" "+item.currency;
                }
            }}
        ];

        let actions = [
            { id : "betLogView", name : "View", className : "btn btn-primary", iconClassName : "fa fa-user", type : ActionType.LINK, getLink : (item : any) => "/sportsbetting/bet-log/" + item.id }
        ];

        return (
            <div className={"card"}>
                <div className="card-header">
                    <h4>Bet Logs</h4>
                </div>
                <EntityDataTable
                    columns={columns}
                    service={getContainer().getSportsBetLogsService()}
                    listRequest={this.state.listRequest}
                    onPagerChange={this.pagerChanged.bind(this)}
                    onAction={()=>undefined}
                    actions={actions}
                />
           </div>
        )
    }

    copyToClipboard(text : string) {
        console.log("copying to clipboard");
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        }
    }


    renderRequestData(){
        if(!this.state.bet){
            return(<span></span>)
        }
        let request = this.state.bet.request;
        let json = "";
        try{
            json = JSON.stringify(JSON.parse(request!), null, 2);
        }catch(e){
            json = request!;
        }
        return (
            <div className={"card-box expandable-box"}>
                {this.state.lookupExpanded && (
                    <>
                    <a className="expand-button float-right" onClick={() => this.setState({ lookupExpanded: false })}><i className="mdi mdi-minus"></i></a>
                    {navigator.clipboard && window.isSecureContext && (
                        <a className="expand-button float-right" onClick={() => {this.copyToClipboard(json)}}><i className="mdi mdi-content-copy"></i></a>
                    )}
                    </>
                )}
                {!this.state.lookupExpanded && (
                    <a className="expand-button float-right" onClick={() => this.setState({ lookupExpanded: true })}><i className="mdi mdi-plus"></i></a>
                )}
                <div>
                    <h4 className="header-title mb-3" onClick={() => this.setState({ lookupExpanded: !this.state.lookupExpanded })}> Bet Original Request
                    </h4>
                    
                </div>

                {this.state.lookupExpanded && (
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card-box">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <textarea 
                                            id={"original-bet-request"} 
                                            style={{whiteSpace: "pre-wrap", wordWrap: "break-word", width: "100%", height: "800px"}} 
                                            disabled
                                            defaultValue={json}
                                            title={""}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
                            
    }


    renderContent() {
        if (!this.state.bet) {
            return <span></span>
        }
        let bet : SportsBet = this.state.bet;
        let userLink = bet.userId ? <Link to={"/user/" + bet.userId}>{bet.userId}</Link> : <div>n/a</div>;
        return (

            <Fragment>
                <div className="row">
                    <div className={"col-lg-12"}>
                        <div className={"row"}>
                            <div className="col-lg-6">
                                <Form className="form form-horizontal" validationMap={this.state.validationMap} modelObject={bet} formListener={this}>
                                    <FormSubmitError />
                                    <FormSubmitSuccess text={"Bet Log was updated successfully"} />
                                    <div className={"card-box"}>
                                        <div className="ibox-content">
                                            <h4>Bet ID : {bet.id}</h4>
                                            <table className={"table table-striped"}>
                                                <tbody>
                                                    <tr> 
                                                        <td>Integration</td>
                                                        <td>{bet.integration}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Source</td>
                                                        <td>{bet.source}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Group Id</td>
                                                        <td>{bet.groupId}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Parent Id</td>
                                                        <td>{bet.parentId}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>User Id</td>
                                                        <td>{userLink}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Bet Created</td>
                                                        <td>{formatDate(bet.created)}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Bet Graded Date</td>
                                                        <td>{formatDate(bet.gradedDate)}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Bet Name</td>
                                                        <td>{bet.name}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Bet Description</td>
                                                        <td>{bet.description}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Bet Type</td>
                                                        <td>{bet.betType}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Currency</td>
                                                        <td>{bet.currency}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Risk Account Role</td>
                                                        <td>{bet.riskAccountRole}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Risk</td>
                                                        <td>{bet.risk}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Original Payout Account Role</td>
                                                        <td>{bet.originalPayoutAccountRole}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Original Payout</td>
                                                        <td>{bet.originalPayout}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Payout Account Role</td>
                                                        <td>{bet.payoutAccountRole}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Payout</td>
                                                        <td>{bet.payout}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Odds</td>
                                                        <td>{bet.odds}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Odds Format</td>
                                                        <td>{bet.oddsFormat}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Status:</td>
                                                        <td>{bet.status}
                                                            <StaticFormValue name="status" className="form-control" model="status" value={bet.status} />
                                                        </td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Updated</td>
                                                        <td>{formatDate(bet.updated)}</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>Updated By</td>
                                                        <td>{bet.updatedBy}</td>
                                                    </tr>                                                   
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                            <div className="col-lg-6">
                                {this.renderRequestData()}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        {this.renderBetSelections()}
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        {this.renderBetLogs()}
                    </div>
                </div>
                {/* show button updata data */}
                {
                    this.state.showModal &&
                    <BetUpdateModal
                        okLabel="OK"
                        onOk={
                           ()=>{this.openModal()} 
                        }
                        onCancel={
                            ()=>{this.confirmationModal()} 
                        }
                        onClose={
                            ()=>{this.closeModal()} 
                        }
                        loadContent={
                            ()=>{this.loadContent()}
                        }
                        heading=""
                        show={this.state.showModal}
                        showModalSelectBet={true}
                        showModalConfirmation={false}
                        bet={bet}
                        service = {this.service}
                    ></BetUpdateModal>
                }

            </Fragment>
        )
    }

}

export default withRouter(BetView);

